import {createSelector} from 'reselect';
import {getLeftMenuOpen, getRightMenuOpen, getConfirm, getConfirmLoader, getSalespersonsName} from '../../App/selectors';

export const selectLeftMenuOpen = createSelector([getLeftMenuOpen], leftMenuOpen => leftMenuOpen);
export const selectRightMenuOpen = createSelector([getRightMenuOpen], rightMenuOpen => rightMenuOpen);
export const selectConfirm = createSelector([getConfirm], confirm => confirm.toJS());
export const selectConfirmLoader = createSelector([getConfirmLoader], loading => loading);
export const selectSalespersonsName = createSelector([getSalespersonsName], salespersonsName => salespersonsName);
